/** @type {import('@sveltejs/kit').ParamMatcher} */
export function match(param) {
	const matches = ['reservations', 'ouvertures', 'livraison', 'emporter', 'phoning'];
	return matches.includes(param);
}
